import React, { Component, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {ROUTES} from '../../routes';
import UserHeader from '../common/UserHeader';
import SidebarNavigation from '../common/SidebarNavigation';
import {PAGINATION_LIMIT} from '../../constants';
//import {authentication} from '../../utilities';
// import '../../bootstrap.css'

class Auth extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: props.user,
      status: props.status
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.compName == 'Auth' && nextProps.status != this.state.status){
      this.setState({
        user: nextProps.user,
        status: nextProps.status
      });
    }
  }

  componentWillMount(){

  }
  
  render() {
    const {user} = this.state;

    let searchParams = new URLSearchParams(this.props.location.search);
    let isValid = searchParams.get('app');
    let isFaq = window.location.pathname;

    //console.log('*****', window.location.href);

    if(typeof user.token == 'undefined' && !isValid){
      return <Redirect to='/login'/>
    }
    
    return (<>
      <section className='auth-screens'>
        {
          !isValid &&
          <UserHeader />
        }
        
        <div id="main-wrapper">
          <div className="container">
            <Switch>
              <Route {...ROUTES.MYTRANSACTIONS} />
              <Route {...ROUTES.MONEYTRANFER} />
              <Route {...ROUTES.KYCVERIFICATIONMETHOS} />
              <Route {...ROUTES.KYCMANUALVERIFICATION} />
              <Route {...ROUTES.KYCDRIVERLICENSE} />
              <Route {...ROUTES.USERPROFILE} />
              <Route {...ROUTES.PAYMENTSUCCESS} />
              <Route {...ROUTES.PAYMENTFAILURE} />
              <Route {...ROUTES.PAYMENTCANCEL} />
              <Route {...ROUTES.PAYMENTNOTIFICATION} />
              <Route {...ROUTES.DIRECTPAYMENTSUCCESS} />
              <Route {...ROUTES.MYWALLET} />
              <Route {...ROUTES.REFERTOFRIEND} />
            </Switch>
          </div>
        </div>
      </section>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: {...state.Auth.user},
    status: state.Auth.status,
    compName: state.Auth.compName
  };
}

export default connect(mapStateToProps)(Auth);